export const selectLessons = state => state.lessons.lessons;

export const selectCurrentLesson = state => state.lessons.currentLesson;

export const selectComments = state => selectCurrentLesson(state).comments;

export const selectMondayLesson = state =>
	selectCurrentLesson(state).MondayLesson;
